import { computed, defineComponent, ref, watch, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
// import { useI18n } from 'vue-i18n';
import * as antIcons from '@ant-design/icons-vue';
// import Scroll from '@convue-lib/scroll';
// import { ActionTypes } from '../../store/index';
// import { Menu } from '@/config/types';
import { ProjectName } from '@/config/app-config'

import { MenuType, MenuChildern } from '@/router/menu'
import './Asider.less'
import { cptSearhStr } from '@/utils';

const Icons: any = antIcons;

export default defineComponent({
  components: {
    ...Icons,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { state } = useStore();
    const router = useRouter();
    const route = useRoute();
    // const { locale } = useI18n();
    const menu = computed(() => state.userMenu);

    // const defaultOpenKeys = () =>
    //   menu
    //     .filter((item: MenuChildern) => item.children?.find((child: MenuChildern) => child.path === route.path))
    //     .map((n: MenuChildern) => n?.meta?.id);

    const defaultOpenKeys = () => {
      let keys: number[] = []
      const findRoute = (menuItem: MenuChildern, tem: Record<number, number>, deep: number) => {
        tem[deep] = menuItem.meta?.id
        if (menuItem.children) {
          for(let ite of  menuItem.children) {
            let _deep = deep + 1
            findRoute(ite, tem, _deep)
            
            if (keys.length) {
              break;
            }
          }
        } else if (menuItem.path === route.path) {
          // console.log(menuItem.meta?.query, route.meta?.query)
          // && JSON.parse(menuItem.meta?.query || {}) === JSON.parse(route.meta?.query)
          keys = Object.values(tem)
        }
      }

      for(let menuItem of menu.value) {
        let tem = {}
        let deep = 1
        findRoute(menuItem, tem, deep)
        
        if (keys.length) {
          break;
        }
      }
 
      return keys
    }

    const openKeys = ref<number[]>(defaultOpenKeys());
    const selectedKeysRef = ref<string[]>([route.path]);

    const onMenuItemClick = ({ key, item }: any) => {
      // router.push({path: key, query: item.query});
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
        router.push({path: key, query: item.query});
      } else {
        const queryStr = cptSearhStr(item.query)
        window.open(key + `${queryStr ? '?' + queryStr : ''}`)
      }
    };

    const onOpenChange = (keys: number[]) => {
      openKeys.value = keys;
    };

    watchEffect(() => {
      selectedKeysRef.value = [route.path];
      openKeys.value = defaultOpenKeys();
    });

    const onSelect = ({ item, key, selectedKeys }: any) => {
      // 因为 menu 新开页面将 sectedKeys 重置为 route path
      selectedKeysRef.value = [route.path]
    }

    const goOld = (event: Event, menu: MenuChildern) => {
      if (menu.meta?.goOld) {
        event.preventDefault()        
        const search = cptSearhStr(menu.meta.query || {})
        const searchStr = search ? '?' + search : ''
        window.open('https://a-webapi.didaadmin.com' + menu.path + searchStr)
      }
    }

    const TitleSlots = (item: MenuChildern) => {
      const IconComponent = Icons[item.meta?.icon as string]
      return (
        <span>
          <IconComponent></IconComponent>
          <span>{item.name}</span>
        </span>
      )
    }

    const placeMenu = (item: MenuChildern) => {
      
      if (!state.userInfo?.isAdmin && !item.meta?.hasPermission) {
        return null
      }

      return (
        item.children ?
        <a-sub-menu
          key={item.meta?.id}
          v-slots={{
            title: () => TitleSlots(item)
          }}
          onClick={event => goOld(event, item)}
        >
          {
            item.children.map((child: MenuChildern) => {
              return (
                placeMenu(child)
              )
            })
          }
        </a-sub-menu> :
        (
          !item.meta?.hiddenInMenu &&
          <a-menu-item  key={item.path} query={item.meta?.query}>
            { TitleSlots(item) }
          </a-menu-item>
        )
      )
    }

    return () => (
      <>
        <router-link to="/" class="logo">
          <a-space>
            <img alt="logo" height="32" src={`/favicon.ico`} />
            {!props.collapsed && <span class="title">{ProjectName}</span>}
          </a-space>
        </router-link>
          <a-menu
            theme="dark"
            mode="inline"
            inline-collapsed={props.collapsed}
            v-models={[
              [selectedKeysRef.value, 'selectedKeys'],
              [openKeys.value, 'openKeys'],
            ]}
            onClick={onMenuItemClick}
            onOpenChange={onOpenChange}
            onSelect={onSelect}
            class="a-menu"
          > 
            {
              menu.value.map((item: MenuType) => {
                return (
                  placeMenu(item)
                )
              })
            }
          </a-menu>
      </>
    );
  },
});
